import { toggleButtonClasses } from '@mui/material/ToggleButton';
import { makeStyles } from 'tss-react/mui';
import { gradientBorder } from '../../../../../../../themes/v2/theme.base';

const SCROLL_FADE_WIDTH = 48;
const SCROLL_FADE_MASK = `linear-gradient(to right, #000 calc(100% - ${SCROLL_FADE_WIDTH}px), transparent)`;

const FILTER_BUTTON_HEIGHT = 24;
const FILTER_BUTTON_MOBILE_HEIGHT = 38;
const DROPDOWN_BUTTON_WIDTH = 22;
const DROPDOWN_BUTTON_MOBILE_WIDTH = 32;

export const useProductFiltersStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    gap: theme.spacing(1),
    minWidth: 0,
    overflowX: 'auto',
    maskImage: SCROLL_FADE_MASK,
    WebkitMaskImage: SCROLL_FADE_MASK,
  },
  filterButton: {
    height: FILTER_BUTTON_HEIGHT,
    textTransform: 'lowercase',
    whiteSpace: 'nowrap',
    color: theme.palette.text.secondary,
    border: '1px solid transparent',
    background: gradientBorder(
      theme.palette.secondary.main,
      theme.palette.custom.gradients.secondaryButton,
    ),
    '&:hover': {
      color: theme.palette.text.primary,
      background: gradientBorder(
        theme.palette.secondary.light,
        theme.palette.custom.gradients.secondaryButtonHover,
      ),
    },
    [`&.${toggleButtonClasses.disabled}`]: {
      color: theme.palette.text.disabled,
      borderColor: theme.palette.custom.border.secondary,
    },
    [theme.breakpoints.between('xs', 'md')]: {
      height: FILTER_BUTTON_MOBILE_HEIGHT,
    },
  },
  lockFilterButton: {
    width: FILTER_BUTTON_HEIGHT,
    minWidth: FILTER_BUTTON_HEIGHT,
    flexShrink: 0,
    padding: 0,
  },
  selectedFilterButton: {
    [`&.${toggleButtonClasses.selected}`]: {
      color: theme.palette.text.primary,
      background: gradientBorder(
        theme.palette.secondary.dark,
        theme.palette.custom.gradients.secondaryButton,
      ),
      '&:hover': {
        background: gradientBorder(
          theme.palette.secondary.dark,
          theme.palette.custom.gradients.secondaryButtonHover,
        ),
      },
    },
  },
  disabledSelectedFilterButton: {
    [`&.${toggleButtonClasses.selected}.${toggleButtonClasses.disabled}`]: {
      color: theme.palette.text.disabled,
      backgroundColor: theme.palette.action.selected,
      borderColor: theme.palette.custom.border.secondary,
    },
  },
  splitButtonTextStyle: {
    fontSize: theme.typography.body2.fontSize,
    fontWeight: theme.typography.body2.fontWeight,
    lineHeight: 1,
    letterSpacing: 0,
  },
  iconDropdownButton: {
    width: DROPDOWN_BUTTON_WIDTH,
    [theme.breakpoints.down('lg')]: {
      width: DROPDOWN_BUTTON_MOBILE_WIDTH,
    },
  },
  deliveryWindowsMenuPaper: {
    boxShadow: 'none',
    border: `1px solid ${theme.palette.custom.border.secondary}`,
    borderRadius: theme.shape.borderRadiusLg,
    paddingBlock: theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
  },
}));
